import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtl from "stylis-plugin-rtl";
import React, { ReactNode } from "react";

// NB: A unique `key` is important for it to work!
const options = {
  rtl: { key: "css-ar", stylisPlugins: [rtl] },
  ltr: { key: "css-en" },
};

interface RtlProviderProps {
  children: ReactNode;
}

export function RtlProvider({ children }: RtlProviderProps) {
  const dir = document.documentElement.dir === "ar" ? "rtl" : "ltr";
  const cache = createCache(options[dir as keyof typeof options]);
  return <CacheProvider value={cache}>{children}</CacheProvider>;
}

